import Vue from 'vue'
import appRoutes from './app';
import authRoutes from './auth';
import Login from '@/views/auth/Login.vue';
import store from '../store';
import guards from "./guards";
import nProgress from 'nprogress';
import VueRouter from 'vue-router';

import { isIframeApp } from '../services/utils';

Vue.use(VueRouter)

const iframeModeRoutes = [
  {
    path: '/',
    redirect: '/dashboard/home'
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true
    }
  },
  ...appRoutes,
];

const fullAppRoutes = [
  ...authRoutes,
  ...appRoutes,
  { path: '/page-not-found', component: () => import(/* webpackChunkName: "app-page-[request]" */`@/views/PageNotFound.vue`)},
  { path: '*', redirect: '/page-not-found' },
];

export const routes = isIframeApp() ? iframeModeRoutes : fullAppRoutes;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    nProgress.start();
  }

  next()
});

router.afterEach(() => {
  nProgress.done();
});

router.beforeEach((to, from, next) => {
  guards.forEach(Guard => {
    new Guard(store).handle(to, from, next);
  });

  next();
});

export default router;